import { Action, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { Api } from './api'
export { Api } from '@/src/store/api'
import devToolsEnhancer from 'redux-devtools-expo-dev-plugin'
import * as clients from '@/src/clients'
import { transformRTKQueryFnActionType } from './listeners'
import { Platform } from 'react-native'

function actionSanitizer<A extends Action>(action: A) {
  return {
    ...action,
    type: transformRTKQueryFnActionType(action),
  }
}

export const store = configureStore({
  reducer: {
    [Api.reducerPath]: Api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      Api.middleware,
      clients.tsrest.store.listeners.sentryTransactions.middleware,
      clients.sentry.store.listeners.captureQueryFnErrors.middleware,
    ]),
  devTools:
    Platform.select({
      native: false,
      web: __DEV__
        ? {
            actionSanitizer,
          }
        : false,
    }) || false,
  enhancers: (getDefaultEnhancers) => {
    const platformEnhancers =
      Platform.select({
        native: __DEV__
          ? [
              devToolsEnhancer({
                actionSanitizer,
              }),
            ]
          : [],
        web: [],
      }) || []

    const baseEnhancers = [clients.sentry.store.enhancers.rtkqSentryEnhancer]

    return getDefaultEnhancers().concat([...baseEnhancers, ...platformEnhancers])
  },
})

setupListeners(store.dispatch)
